export default {
  list: {
    create: "invoice",
    require: {
      invoiceNumber: "invoice number",
      country: 'country',
      currency: 'currency',
      term: 'default invoice term',
      tax: 'default VAT',
    },

    export: "Download invoices",
  },

  create: {
    saveAndReadyToSend: "and ready to send",
    cancel: "Cancel",
  },

  edit: {
    delete: "Invoice",

    makeCredit: "Create credit invoice",

    newVersion: "New version",
    invoiceDateToToday: "Set invoice dates to today",

    require: {
      email: "email address",
      address: "address",
      bankAccount: "bankaccount",
      businessNumbers: "business numbers",
    },

    send: {
      email: {
        invoice: "Send by email",
        reminder: "Send reminder email"
      },
    },

    print: {
      pdf: {
        download: "Download PDF",
        example: "Example PDF",
      },
      require: {
        clientData: "Expand client details",
        printTemplate: "print template",
      },
    },

    status: {
      offer: "Offer",
      draft: "Draft",
      readyToSend: "Ready to send",
      selfSend: "Print and send",
      paid: "Paid",
      irrecoverable: "Irrecoverable",
    },
  },
}
